module.exports = __webpack_public_path__ + "images/icon_delete.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/icon_delete.svg
// module id = 26
// module chunks = 0